/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestManagementCatalogComponent {
    getFixupPrototypeFunction() { return ServiceNowRequestManagementCatalogComponent.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestManagementCatalogComponent>): ServiceNowRequestManagementCatalogComponent {
        let obj = Object.assign(new ServiceNowRequestManagementCatalogComponent(), model);
        ServiceNowRequestManagementCatalogComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestManagementCatalogComponent>): ServiceNowRequestManagementCatalogComponent {
        if (!model) return null;
        return ServiceNowRequestManagementCatalogComponent.newInstance(<ServiceNowRequestManagementCatalogComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestManagementCatalogComponent) {
        if (!obj) return;

        models.ServiceNowRequestManagementCatalogComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestManagementCatalogComponent): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestManagementCatalogComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Title for Request Management Catalog Item
     */
    title: string;

    /**
     * SysID for Request Management Catalog Item
     */
    sys_id: string;

    /**
     * Name for Request Management Catalog Item
     */
    name: string;

    /**
     * Level 1 for Request Management Catalog Item
     */
    level1: string;

    /**
     * Level 2 for Request Management Catalog Item
     */
    level2: string;

    /**
     * Classification Name for Request Management Catalog Item
     */
    classification_name: string;

    /**
     * Label for Request Management Catalog Item
     */
    label: string;

    /**
     * Id for Request Management Catalog Item
     */
    item_id: string;

}
